const Form099EN = {
    stepName: {
        importantNotes: "Important Notes",
        competitionRules: "Competition Regulations",
        basicInfo: "Basic Information",
        confirmation: "Confirmation",
        formA: "Declaration",
    },
    importantNotes: {
        tableTitle:
            "Hong Kong Budding Scientists Award Student Nomination Form",
        follow: "Please pay attention to the following:",
        num: {
            n1: "(1) ",
            n2: "(2) ",
            // n3: "(3) ",
            // n4: "(4) ",
            // n5: "(5) ",
            // n6: "(6) ",
        },
        n1: "All information related to the competition will be uploaded to the competition webpage <a href='http://www.edb.gov.hk/en/BSA' target='_blank' rel='noreferrer'>http://www.edb.gov.hk/en/BSA</a>.",
        n2: "Participating schools must visit the competition webpage regularly to check for the latest updates, as no further notifications will be issued by the EDB.",
        // serial: ["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)"],

        // n1: "Schools should inform students and their parents/guardians that in the course of the competition, the EDB and persons/parties authorised by the EDB may take photographs and videos in which the students appear. The photographs and videos may be used for publicity purposes by the EDB in print or digitally. Schools or parents/guardians who have any concern about the arrangement may write to <a href='mailto:cdoge1@edb.gov.hk'>cdoge1@edb.gov.hk</a>.",

        // n2: "Eligibility:",
        // n21: "Primary Section: each primary school ought to nominate three to five P.4 to P.6 students (at most two P.6 students);",
        // n22: "Secondary Section: each secondary school ought to nominate three to five S.1 to S.4 students (at most two S.4 students);",
        // n23: "Team members CANNOT be replaced once the Student Nomination Form is submitted.",

        // n3: "Please check the submitted information carefully. Related information, including the entries of this competition will be used for the printing of corresponding certificates and booklet of the Hong Kong Budding Scientists Award or other educational uses.",
        // n4: "The entries of this competition must be original and must not infringe any copyrighted materials. Schools are not allowed to submit students’ products which have been used in other competitions for the Hong Kong Budding Scientists Award.",
        // n5: "All information related to this competition including students' results and arrangements of the Heat, Final cum Prize Presentation Ceremony will be uploaded to the competition webpage <a href='http://www.edb.gov.hk/en/BSA' target='_blank' rel='noreferrer'>http://www.edb.gov.hk/en/BSA</a>.",
        // n6: "Participating schools are required to check the competition webpage regularly for the updates without further notification.",
    },
    competitionRules: {
        num: {
            n1: "(1) ",
            n2: "(2) ",
            n3: "(3) ",
            n4: "(4) ",
        },
        n1: "Schools must inform students and their parents/guardians that during the competition, the EDB and its authorised representative(s) may take photographs or videos in which students could appear. These materials may be used by the EDB for promotional purposes in both print and digital formats.",
        n2: "Please ensure that the submitted information is accurate. The details, including competition entries, will be used for preparing the relevant award certificates, the compilation booklet of the Hong Kong Budding Scientists Award, and other educational purposes.",
        n3: "Originality and Eligibility of Entries",
        n4: "If a participating team fails to declare or delays reporting on the use of artificial intelligence, external support, or originality, the EDB reserves the right to reject or disqualify any entry without explanation.",
        
        originalityTable: {
                originality:  { title: "Originality of Work", content: "The scientific investigation submitted for HKBSA need not be entirely novel to the science field, but must demonstrate originality in one or more dimensions, including but not limited to the rationale of inquiry, experimental design and methodology, and data analysis and interpretation." },
                copyright:    { title: "Copyright Compliance",   content: "All entries must be original creations of the participating students and must not infringe upon any copyright or intellectual property rights." },
                duplicate:    { title: "Duplicate Entries",   content: "Schools shall not submit student work that has previously been entered in, or is intended for submission to, any other local or non local competition within the same school year." },
                declaration:  { title: "Declaration of Originality", content: "Participating schools and students are required to declare the originality of their work in the Nomination Form, acknowledging compliance with the above requirements." },
        },
    },
    informationOfSchool: {
        title: "Information of Participating School",
        section: "Section",
        primary: "Primary Section",
        secondary: "Secondary Section",
        schoolEngName: "Name of School (in English)",
        schoolChName: "Name of School (in Chinese)",
        schoolTel: "School Tel. No.",
        schoolFax: "School Fax. No.",
    },
    event: {
        title: "Competition Event",
        eventOption: {
            scientific: "Scientific Investigation Report",
            scientist: "Scientist Interview Report",
        },
    },
    sectionA: {
        title: "Personal Particulars of Coach Teacher(s)",
        teacherEngName: "Name of Teacher(s) (in English)",
        teacherChName: "Name of Teacher(s) (in Chinese)",
        mobile: "Mobile",
        email: "Email",
        schoolEngName: "Name of School (in English)",
        schoolChName: "Name of School (in Chinese)",
        schoolTel: "School Tel. No.",
        schoolFax: "School Fax. No.",
    },
    sectionB: {
        title: "(B) Student Contestants",
        engName: "Name in English",
        chName: "Name in Chinese",
        form: "Form",
        formTips:
            "Eligibility: \nPrimary Section: each primary school ought to nominate three to five P.4 to P.6 students (at most two P.6 students); \nSecondary Section: each secondary school ought to nominate three to five S.1 to S.4 students (at most two S.4 students); \nTeam members CANNOT be replaced once the Student Nomination Form is submitted.",
        formOption: {
            p4: "P.4",
            p5: "P.5",
            p6: "P.6",
            s1: "S.1",
            s2: "S.2",
            s3: "S.3",
            s4: "S.4",
        },
        formPriOption: {
            p4: "P.4",
            p5: "P.5",
            p6: "P.6",
        },
        formSecOption: {
            s1: "S.1",
            s2: "S.2",
            s3: "S.3",
            s4: "S.4",
        },
    },
    label: {
        selectedLanguage:
            "Please put a ✓ against the selected language for the competition",
        signatureHead: "Signature School Head",
        headName: "Name of School Head",
        date: "Date",
        schoolChop: "School Chop",
        selectLangOption: {
            chinese: "Chinese",
            english: "English",
        },
        selectSectionOption: {
            primary: "Primary Section",
            secondary: "Secondary Section",
        },
        confirmation: "I confirm that I have carefully read and agree to the Personal Information Collection Statement, the Competition Regulations, and the Important Notes.",
    },
    errorMsg: {
        faxMax12: "Fax number must be at most 12 digits",
        selectOneSection:
            "Please select the same grade to participate in the competition",
        selectListP:
            "Each primary school ought to nominate three to five P.4 to P.6 students",
        selectListS:
            "Each secondary school ought to nominate three to five S.1 to S.4 students",
        selectMoreP: "At most two P.6 students",
        selectMoreS: "At most two S.4 students",
        selectLeastP:
            "Each primary school ought to nominate three to five students",
        selectLeastS:
            "Each secondary school ought to nominate three to five students",
        selectLeast: "Each school ought to nominate three to five students",
    },
    formExpired:
        "The student nomination for the Hong Kong Budding Scientists Award is closed.",
};
export default Form099EN;
